/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const pagedListOfClientMainDataSchema = z.object({
  items: z.array(
    z.object({
      id: z.coerce.number().int(),
      name: z.coerce.string().min(1).max(500),
      enabled: z.boolean(),
    }),
  ),
  pageNumber: z.coerce.number().int(),
  totalPages: z.coerce.number().int().optional(),
  pageSize: z.coerce.number().int(),
  currentPageSize: z.coerce.number().int().optional(),
  currentStartIndex: z.coerce.number().int().optional(),
  currentEndIndex: z.coerce.number().int().optional(),
  totalCount: z.coerce.number().int().optional(),
  hasPrevious: z.boolean().optional(),
  hasNext: z.boolean().optional(),
  nextPageNumber: z.coerce.number().int().nullable().nullish(),
});
